fragment Client on Client {
    _id
    id
    name
    logoUrl
    imageProcessingEnabled
    connectModuleEnabled
    creativeXPlatformSettings {
        enabled
        brandId
        threshold
        secretId
    }
    sataliaPlatformSettings {
        enabled
        domain
    }
}
